import React from 'react';
import { Card } from 'react-bootstrap';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
  LabelList
} from 'recharts';

const palette = [
  '#4e73df', '#1cc88a', '#36b9cc',
  '#f6c23e', '#e74a3b', '#858796'
];

const BarChartCard = ({ title, data, styles: css, img }) => {
  const maxCount = Math.max(...data.map(d => d.count)) + 2;

  return (
    <Card className={css.boxShadow}>
      <Card.Header className={css.CardHeader}>
        {img}{title}
      </Card.Header>

      <Card.Body style={{ padding: 0 }}>
        <ResponsiveContainer width="100%" height={220}>
          <BarChart
            data={data}
            margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
          >
            <XAxis dataKey="stage" hide={true} />
            <YAxis domain={[0, maxCount]} />

            <Tooltip
              cursor={{ fill: 'rgba(0,0,0,0.05)' }}
              formatter={(val) => [val, 'Cantidad']}
            />

            <Bar dataKey="count" barSize={30}>
              {data.map((entry, idx) => (
                <Cell
                  key={entry.stage}
                  fill={palette[idx % palette.length]}
                />
              ))}
              <LabelList
                dataKey="count"
                position="top"
                style={{ fontSize: 12, fill: '#333' }}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>

        <div className={css.customLegend}>
          {data.map((entry, idx) => (
            <div key={entry.stage} className={css.legendItem}>
              <span
                className={css.colorBox}
                style={{ backgroundColor: palette[idx % palette.length] }}
              />
              <span className={css.legendLabel}>{entry.stage}</span>
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default BarChartCard;
